export enum DynamicFieldType {
	TEXT = "text",
	NUMBER = "number",
  SELECT = "select",
  RADIO = "radio",
  CHECKBOX = "checkbox",
  SLIDER = "slider",

	BOOLEAN = "boolean",
  TEXT_AREA = "textArea",
	DATE = "date",

  SECRET = "secret",
  SERVICE = 'service',
  PLUGIN_SERVICE = 'plugin-service',
}

enum Format {
  html = "html",
  markdown = "markdown",
  text = "text",
  password = "password",
  email = "email",
  url = "url",
  phone = "phone",
  date = "date",
  time = "time",
  datetime = "datetime",
}

export interface FieldType {
	name: string;
	type: DynamicFieldType;
	label: string;
	required?: boolean;
	description?: string;
	placeholder?: string;
	options?: { value: string; label: string; description?: string }[];
  value?: string;
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  multiline?: boolean;
  format?: Format;
  showPlaceholder?: boolean;
  defaultValue?: number;
  withCustomFields?: boolean;
  isIndex?: boolean;
  serviceType?: string;
  summaryInfo?: any;
}